import { SYSTEMS } from '../../constants/systems';
import { useGetGraphQueries, useGetSSRsQueries, useSetAndCurrentTemp } from '../../hooks';
import { useTemperature } from '../../hooks/useTemperature';
import SwitchWrapper from '../commonComponentsMC/SwitchWrapper';
import InputTempMessage from '../userMessages/inputTempMessage';
import { MessageBoxWrapper, SectionMainContentExpand, Wrapper } from './frameStyles';
import MachineHeader from './MachineHeader';
import MachineSummary from './MachineSummary';
import { cardTitle, consumptionOf } from './machineCardFacts';
import MobileMachineCard from './MobileMachineCard';
import { useMachineCard } from './useMachineCard';

// Fetches the device's SSRs. A component of its own so only systems with
// SSRs mount the query, without a conditional hook call.
const FetchSSRs = ({ location, machine, system }) => {
  useGetSSRsQueries(location, machine, system);
  return null;
};

/**
 * One device's card on the master-control page for ESS, TGS or TES
 * (`swtName`). Collapsed, it shows the device's state and quick controls;
 * expanded, its full controls (SwitchWrapper on desktop, ControlBox on
 * mobile).
 */
const MachineCard = ({
  swtName,
  location,
  machine,
  isMobile,
  selectedProgramSrc,
  indivLocationName,
}) => {
  const { deviceType, hasSSRs } = SYSTEMS[swtName];
  const card = useMachineCard({ system: swtName, location, machine });
  const { device } = card;
  const { isF } = useTemperature();
  const temps = useSetAndCurrentTemp(device);
  useGetGraphQueries(location, machine, deviceType);

  const view = {
    ...card,
    system: swtName,
    location,
    machine,
    temps,
    title: cardTitle(device, swtName, isMobile),
    consumption: consumptionOf(device, swtName, isF),
  };

  return (
    <>
      {hasSSRs && <FetchSSRs location={location} machine={machine} system={swtName} />}
      {isMobile ? (
        <MobileMachineCard
          {...view}
          selectedProgramSrc={selectedProgramSrc}
          indivLocationName={indivLocationName}
        />
      ) : (
        <Wrapper isExpanded={device.openMachineController}>
          <MachineHeader
            system={swtName}
            location={location}
            device={device}
            title={view.title}
            onClose={card.close}
          />
          {device.openMachineController ? (
            <SectionMainContentExpand>
              <SwitchWrapper
                swtName={swtName}
                location={location}
                machine={machine}
                indivLocationName={indivLocationName}
              />
            </SectionMainContentExpand>
          ) : (
            <MachineSummary {...view} />
          )}
          {card.message && (
            <MessageBoxWrapper>
              <InputTempMessage
                onClose={card.closeMessage}
                messages={card.message}
                title='instant heat'
                subtitle='instant heat program'
              />
            </MessageBoxWrapper>
          )}
        </Wrapper>
      )}
    </>
  );
};

export default MachineCard;
